import PropTypes from 'prop-types'
import styled from 'styled-components'

import ChartContainer from 'components/Shared/charts/Chart'

const StyledWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 0;
  border-radius: 3px;
  background-color: #FFFFFF;
`

const ChartWrapper = styled.div`
  display: flex;
  flex: 1;
  width: 100%;
`

const BondedUnbondedTicketsChart = ({ bondedUnbondedTickets, userTimeZoneAbbr, userTimeFormat24 }) => {
  const chartConfig = {
    type: 'column',
    displayTimezone: userTimeZoneAbbr,
    timeFormat24: userTimeFormat24,
  }

  return (
    <StyledWrapper>
      <ChartWrapper>
        <ChartContainer config={chartConfig} data={bondedUnbondedTickets} />
      </ChartWrapper>
    </StyledWrapper>
  )
}

BondedUnbondedTicketsChart.propTypes = {
  bondedUnbondedTickets: PropTypes.array,
  userTimeZoneAbbr: PropTypes.string,
  userTimeFormat24: PropTypes.bool,
}

export default BondedUnbondedTicketsChart
